/**
 * Created by ptdave on 6/4/17.
 */

import {Component, Input, OnChanges} from '@angular/core';
import {StudentService} from '../../services/student.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {StudentContactDialog} from '../contact/student.contact.component';
import {Staff} from '../../models/staff.model';
import {ToastService} from '../../services/toast.service';
import {PrintOptions} from '../../common/components/buttons/print-options.helper';
import {ContactLogDto} from '@sidr/dto-types';

@Component({
  selector: `student-communication`,
  templateUrl: 'student.communication.component.html'
})
export class StudentCommunicationComponent implements OnChanges {

  @Input() printOptions: PrintOptions;
  @Input() districtId: string;
  @Input() studentId: string;

  contacts: ContactLogDto[];

  staff: Staff[];
  loading: boolean;

  NotificationTitle = 'Communication';


  ngOnChanges() {
    if (this.districtId && this.studentId) {
      this.getData();
    }
  }


  getData() {
    this.studentService.getContacts(this.districtId, this.studentId).subscribe(resp => {
      this.contacts = resp || [];
      this.contacts.sort((a: ContactLogDto, b: ContactLogDto) => {
        return a.date > b.date ? -1 : 1;
      });
    }, (resp) => {
      this.contacts = [];
    });

  }

  newContact() {
    const m = this.modalService.open(StudentContactDialog, {
      size: 'lg',
      keyboard: false,
      centered: true,
      animation: true
    });
    m.componentInstance.contact = {
      date: new Date()
    };
    m.componentInstance.studentId = this.studentId;
    m.componentInstance.districtId = this.districtId;
    m.componentInstance.staff = this.staff;
    m.componentInstance.edit = true;
    m.result.then(resp => {
      this.getData();
    });
  }

  openContact(c: ContactLogDto) {
    const m = this.modalService.open(StudentContactDialog, {
      size: 'lg',
      keyboard: false,
      animation: true,
      centered: true
    });
    m.componentInstance.contact = c;
    m.componentInstance.studentId = this.studentId;
    m.componentInstance.edit = false;
    m.componentInstance.districtId = this.districtId;
    m.result.then((resp) => {
      console.log(resp);
      this.getData();
    });
  }

  constructor(private studentService: StudentService,
              private modalService: NgbModal,
              private toastService: ToastService) {
    this.contacts = [];
    this.staff = [];
  }
}
